module.exports = __webpack_public_path__ + "media/images/forms-section-button-da70e687.gif";